export default __webpack_public_path__ + "static/media/search-svgrepo-com.de72f29a.svg";